export default "__VITE_ASSET__BJbo_O23__"